import {FederatedAuthPlatform} from "./federated-auth.service";
import {UpdateSignupFlowDataCommand} from "homey-housing-lottery-app-dto";

export interface Tokens {
  idToken: string;
  accessToken: string;
  source: 'username-password' | FederatedAuthPlatform;
}

export type AuthType = 'google' | 'apple' | 'username-password';

export interface OAuthState {
  initialFormCommand: Omit<UpdateSignupFlowDataCommand, 'metadata' | 'paymentLocationGroup'> | undefined;
  redirectUrl: string | undefined;
}

export type SignupResult = 'success' | 'invalid-password' | 'google-account' | 'apple-account';
export type LoginResult = 'success' | 'invalid-email' | 'invalid-password' | 'google-account' | 'apple-account';

export abstract class AuthService {
  abstract getLoginMethod(): Promise<'socials' | 'username-password' | undefined>;
  abstract retrieveData(): Promise<void>;
  abstract getTokens(): Promise<Tokens | undefined>;
  abstract socialLogin(platform: FederatedAuthPlatform, oauthState: OAuthState): Promise<void>;
  abstract logout(): Promise<void>;
  abstract signup(email: string, password: string, oauthState: OAuthState): Promise<SignupResult>;
  abstract changePassword(passwords: {oldPassword: string; newPassword: string}): Promise<void>;
  abstract onFederatedLoginCallback(code: string): Promise<void>;
  abstract loginCallBack(authState: OAuthState): Promise<void>;
  abstract homeyLogin(email: string, password: string, redirectUrl: string): Promise<LoginResult>;
  abstract homeyForgotPassword(email: string): Promise<void>;
  abstract homeyConfirmResetPassword(email: string, code: string, newPassword: string): Promise<void>;
  abstract onUnauthorized(): Promise<void>;
}
